// src/pages/locations/tabs/CitiesTab.tsx
import React from "react";
import { useNavigate } from "react-router-dom";

import ConfirmDialog from "@/components/shared/ui/ConfirmDialog";
import CitiesTable from "@/components/locations/cities/CitiesTable";

import { useCitiesList } from "../hooks/useCitiesList";
import { useLocationScope } from "../useLocationScope";
import { locationEditPath } from "../locations.access";
import { RefreshingStrip, SelectCountryNotice } from "../components/LocationFilters";

const CitiesTab: React.FC = () => {
  const navigate = useNavigate();
  const { country, region, search, scope } = useLocationScope();

  const {
    regions,
    filters,
    setFilters,
    page,
    setPage,
    pageSize,
    rows,
    total,
    isLoading,
    isFetching,
    deleting,
    confirmDelete,
    askDelete,
    cancelDelete,
    confirmDeleteRow,
  } = useCitiesList({ countryIso2: country, region, search });

  return (
    <>
      <RefreshingStrip show={isFetching && !isLoading && Boolean(country)} />

      {!country ? (
        <SelectCountryNotice entity="cities" />
      ) : (
        <CitiesTable
          rows={rows}
          page={page}
          pageSize={pageSize}
          total={total}
          isLoading={isLoading || isFetching}
          filters={filters}
          setFilters={setFilters}
          onPageChange={setPage}
          onEdit={(row) => navigate(locationEditPath("cities", row.id, scope))}
          onDelete={askDelete}
          regions={regions}
        />
      )}

      <ConfirmDialog
        open={confirmDelete.open}
        title="Delete city"
        message={
          confirmDelete.row
            ? `Delete city "${confirmDelete.row.name}"?`
            : "Delete this city?"
        }
        confirmText={deleting ? "Deleting…" : "Delete"}
        cancelText="Cancel"
        onCancel={cancelDelete}
        onConfirm={confirmDeleteRow}
      />
    </>
  );
};

export default CitiesTab;
